import { Button, Input } from '@breetometer/components';
import { EyeIcon } from 'BreetAssets';
import type { IPasswordInput } from 'BreetHelpers';
import { type InvalidEvent, useCallback, useState } from 'react';

const PasswordInput = ({ id, ...rest }: IPasswordInput) => {
	const [showPassword, setShowPassword] = useState<boolean>(false);

	const handlePassword = useCallback(() => {
		setShowPassword((prev) => !prev);
	}, []);

	const onInputInvalid = useCallback((e: InvalidEvent<HTMLInputElement>) => {
		e.preventDefault();
	}, []);

	return (
		<div
			className='password_input'
			data-testid='password-input'
		>
			<Input
				{...rest}
				type={showPassword ? undefined : 'password'}
				onInvalid={onInputInvalid}
				id={id ?? ''}
			/>
			<Button
				variant='native'
				type='button'
				className='show-password'
				onClick={handlePassword}
			>
				<EyeIcon type={showPassword ? '' : 'close'} />
			</Button>
		</div>
	);
};

export default PasswordInput;
